import { IpPortMode, type InputPort, type OutputPort } from 'common/api/v1/types'
import {
    formatTransformationType,
    inputPortModeLabel,
    NOT_CONFIGURED_TYPE_LABEL,
    outputPortModeLabel,
} from 'common/portModeLabel'

export { formatTransformationType }

function submodes(port: InputPort | OutputPort) {
    if (port.mode === IpPortMode.zixi) return { zixiMode: port.zixiMode }
    if (port.mode === IpPortMode.srt) return { srtMode: port.srtMode }
    return {}
}

export function inputTypeFromPort(port: InputPort) {
    return inputPortModeLabel(port.mode, submodes(port))
}

export function outputType(port?: OutputPort) {
    if (!port) {
        return NOT_CONFIGURED_TYPE_LABEL
    }
    return outputPortModeLabel(port.mode, submodes(port))
}
